module.exports = __webpack_public_path__ + "img/banner.b93c56eb.png";